import React, { useEffect, useState } from "react";
import { Table, Badge, Button, Spinner } from "react-bootstrap";
import { Trash, RefreshCw, Slash,Copy } from "react-feather";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme } from "../ThemeContext";
import { apifetch } from '../services/interceptors';
const statusMap = {
  unused: { text: "Unused", variant: "success" },
  opened: { text: "Opened", variant: "success" },
  created: { text: "Unused", variant: "success" },
  used: { text: "Used", variant: "secondary" },
  revoked: { text: "Revoked", variant: "danger" },
};

export default function ScanLinksTable() {
  const { isDarkMode } = useTheme();
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({
  id: null,
  type: null,
});

  const [copiedId, setCopiedId] = useState("");

  const token = localStorage.getItem("token");

  const fetchLinks = async () => {
    setLoading(true);
    try {
      const res = await apifetch("/s2/api/scan-links", {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setLinks(data.links || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);
const handleDelete = async (id) => {
  if (isLoading(id, "delete")) return;

  setActionLoading({ id, type: "delete" });

  try {
    await apifetch("/s2/api/scan-links", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ link: id }),
    });

    setLinks((prev) => prev.filter((l) => l.id !== id));
  } catch (err) {
    console.error(err);
  } finally {
    setActionLoading({ id: null, type: null });
  }
};
const isLoading = (id, type) =>
  actionLoading.id === id && actionLoading.type === type;

const handleRevoke = async (id) => {
   if (isLoading(id, "revoke")) return;
   setActionLoading({ id, type: "revoke" });


  try {
    await apifetch("/s2/api/scan-links/revoke", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ link: id }),
    });

    setLinks((prev) =>
      prev.map((l) =>
        l.id === id ? { ...l, status: "revoked" } : l
      )
    );
  } finally {
   setActionLoading({ id: null, type: null });
  }
};


  const handleRegenerate = async (id) => {
    if (isLoading(id, "regen")) return;

  setActionLoading({ id, type: "regen" });

  try {
    const res = await apifetch("/s2/api/scan-links/regenerate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ link: id }),
    });

    if (!res.ok) throw new Error("Failed");

    const data = await res.json();

    setLinks((prev) =>
      prev.map((l) =>
        l.id === id
          ? {
              ...l,
              link: data.fullLink,
              status: "unused",
              run_count: 0,
              max_runs: 1,
              expires_at: new Date(
                Date.now() + 7 * 24 * 60 * 60 * 1000
              ).toISOString(),
            }
          : l
      )
    );
  } catch (err) {
    console.error(err);
  } finally {
  setActionLoading({ id: null, type: null });
  }
};


  const handleCopy = async (id,url) => {
  
    await navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(""), 2000);
  };

  return (
    <div className={isDarkMode ? "text-light" : "text-dark"}>
      <div className="d-flex justify-content-between align-items-center mb-3">
  <h5 className={isDarkMode ? "text-light" : "text-dark"}>All Scan Links</h5>
  <Button
    size="sm"
    variant="info"
    disabled={loading}
    onClick={fetchLinks}
    className={isDarkMode ? "text-light" : "text-dark"}
  >
    {loading ? (
      <Spinner size="sm" animation="border" />
    ) : (
      "Refresh All"
    )}
  </Button>
</div>


      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
          data-bs-theme={isDarkMode ? "dark" : "light"}
        >
          <thead>
            <tr>
              <th>No.</th>
              <th>Target</th>
              <th>Modules</th>
              <th>Status</th>
              <th>Expires At</th>
              <th>Used At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <AnimatePresence>
              {links.map((link,i) => (
                <motion.tr
                  key={link.id}
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <td>{i+1}</td>
                  <td>{link.target}</td>
                  <td>{link.modules.join(", ")}</td>
                  <td>
                    <Badge bg={statusMap[link.status]?.variant || "secondary"}>
                      {statusMap[link.status]?.text || link.status}
                    </Badge>
                  </td>
                  <td>{new Date(link.expires_at).toLocaleString()}</td>
                  <td>
                    {link.used_at ? new Date(link.used_at).toLocaleString() : "-"}
                  </td>
                  <td className="d-flex gap-2">
                    <Button
  size="sm"
  variant="warning"
  disabled={isLoading(link.id, "regen")}
  onClick={() => handleRegenerate(link.id)}
>
  {isLoading(link.id, "regen") ? (
    <Spinner size="sm" animation="border" />
  ) : (
    <RefreshCw size={14} />
  )}
</Button>

<Button
  size="sm"
  variant="danger"
  disabled={isLoading(link.id, "revoke") || link.status === "revoked"}
  onClick={() => handleRevoke(link.id)}
>
  {isLoading(link.id, "revoke") ? (
    <Spinner size="sm" animation="border" />
  ) : (
    <Slash size={14} />
  )}
</Button>

<Button
  size="sm"
  variant="outline-danger"
  disabled={isLoading(link.id, "delete")}
  onClick={() => handleDelete(link.id)}
>
  {isLoading(link.id, "delete") ? (
    <Spinner size="sm" animation="border" />
  ) : (
    <Trash size={14} />
  )}
</Button>

                   
                    <Button
                      size="sm"
                      variant={isDarkMode ? "outline-secondary" : "secondary"}
                      onClick={() => handleCopy(link.id,link.link)}
                    >
                      {copiedId === link.id ? "Copied!" : <Copy size={14} />}
                    </Button>
                  </td>
                </motion.tr>
              ))}
            </AnimatePresence>
          </tbody>
        </Table>
      )}
    </div>
  );
}
